define('shoptheme/components/blocks/fce/elements/usps',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"scrollreveal"
], function(
	$,
	Component,
	BEM,
	ScrollReveal
) {
	return Component.create({
		blocks:			null,

		$init: function() {
			this.blocks = BEM.block("elements-usps");

			var items = this.blocks.getElements("list-item");
			var heroItem = this.blocks.getElements("hero-usp");
			var allItems = items.add(heroItem);

			if (!allItems.length) {
				return;
			}

			var reveal = ScrollReveal();

			reveal.reveal(allItems, {
				rotate: {x: 65},
				reset: true
			}, 100);
		}
	});
});
